import spanish from '@/assets/landing/ic_spanish.svg'
import english from '@/assets/landing/ic_english.svg'
import catalan from '@/assets/landing/ic_catalunia.svg'
import euskera from '@/assets/landing/ic_euskera.svg'
import francais from '@/assets/landing/ic_francais.svg'
import deutsch from '@/assets/landing/ic_deutsch.svg'
import spanishWhite from '@/assets/landing/ic_white_spanish.svg'
import englishWhite from '@/assets/landing/ic_white_english.svg'
import catalanWhite from '@/assets/landing/ic_white_catalunia.svg'

export const locales = {
  spanish: 'ES_AR',
  catalan: 'ES_CA',
  english: 'EN_US'
}

export const localesToMoment = {
  ES_AR: 'es',
  EN_US: 'en',
  ES_CA: 'ca'
}

export const languagesCodes = {
  ES_AR: 1,
  EN_US: 2,
  ES_CA: 3,
  ES_EU: 4,
  FR_FR: 5,
  DE_DE: 6
}

export const supportedLanguages = [
  { lang: locales.spanish, icon: spanish, white_icon: spanishWhite, label: 'Español', translation: 'spanish' },
  { lang: locales.english, icon: english, white_icon: englishWhite, label: 'English', translation: 'english' },
  { lang: locales.catalan, icon: catalan, white_icon: catalanWhite, label: 'Català', translation: 'catalan' }
]

export const allLanguages = [
  {
    icon: spanish,
    lang: 'ES_AR',
    language: 'spanish',
    code: languagesCodes.ES_AR,
    label: 'Español',
    default: true
  },
  {
    icon: catalan,
    lang: 'ES_CA',
    language: 'catalan',
    code: languagesCodes.ES_CA,
    label: 'Català',
    default: true
  },
  {
    icon: english,
    lang: 'EN_US',
    language: 'english',
    code: languagesCodes.EN_US,
    label: 'English',
    default: true
  },
  {
    icon: euskera,
    lang: 'ES_EU',
    language: 'euskera',
    code: languagesCodes.ES_EU,
    label: 'Euskera',
    default: false
  },
  {
    icon: francais,
    lang: 'FR_FR',
    language: 'french',
    code: languagesCodes.FR_FR,
    label: 'Français',
    default: false
  },
  {
    icon: deutsch,
    lang: 'DE_DE',
    language: 'german',
    code: languagesCodes.DE_DE,
    label: 'Deutsch',
    default: false
  }
]

export const languagesCodesToString = {
  1: 'ES_AR',
  2: 'EN_US',
  3: 'ES_CA',
  4: 'ES_EU',
  5: 'FR_FR',
  6: 'DE_DE'
}

export const mapLanguageOptions = (language) => ({
  ...language,
  id: language.lang,
  label: `
    <div class='row middle'>
      <img class='m4-right-2' src='${language.icon}'/>
      <p class='text-normal'>${language.label}</p>
    </div>
  `
})
